import PropTypes from 'prop-types';
import { forbidExtraProps } from 'airbnb-prop-types';

import { connect } from 'react-redux';

import { MetaData } from 'Components/MetaData';

import { LegacyBaseScene as BaseScene } from 'Scenes/LegacyBaseScene';

import * as userSelectors from 'dux/user/selectors';

import ProspectLandingPage from './ProspectLandingPage';
import SubscriberLandingPage from './SubscriberLandingPage';

export const MembershipScene = ({ header, footer, hasSubscription }) => (
  <>
    <MetaData
      description="Subscribe & save with Prose’s subscription service - The Salon! Save 15% on all orders and earn free products with every 10 items purchased, cancel anytime!"
      title="The Salon - Prose Subscription Service | Prose"
    />

    <BaseScene
      background="earth"
      display="flex"
      footer={footer}
      header={header}
      justifyContent="start"
    >
      {hasSubscription ? <SubscriberLandingPage /> : <ProspectLandingPage />}
    </BaseScene>
  </>
);

MembershipScene.propTypes = forbidExtraProps({
  hasSubscription: PropTypes.bool.isRequired,
  header: PropTypes.bool,
  footer: PropTypes.bool,
});

MembershipScene.defaultProps = {
  header: true,
  footer: true,
};

export default connect(
  state => ({
    hasSubscription: userSelectors.getHasSubscription(state),
  }),
  {}
)(MembershipScene);
